import {useState} from "react";
import axios from "axios";

const uri = "https://manzil.uz.taxi/api/v1";
// const uri = "http://localhost:3009/api/v1";
// const uri = "http://185.224.219.1:3005/api/v1";

export default ({url, method, body, headers, onSuccess, url2}) => {
    const [errors, setErrors] = useState(null);
    const [loading, setLoading] = useState(false);

    const doRequest = async (id, bodyData) => {
        try {
            setErrors(null);

            setLoading(true);
            let response;
            if (url2) {
                if (id) {
                    response = await axios({
                        method: method,
                        url: `${url2}/${id}`,
                        data: body,
                        headers,
                    });
                } else {
                    response = await axios({
                        method: method,
                        url: `${url2}`,
                        data: body,
                        headers,
                    });
                }
            } else {
                if (id && bodyData) {
                    response = await axios({
                        method: method,
                        url: `${uri}${url}/${id}`,
                        data: bodyData,
                        headers,
                    });
                } else if (id) {
                    response = await axios({
                        method: method,
                        url: `${uri}${url}/${id}`,
                        data: body,
                        headers,
                    });
                } else {
                    response = await axios({
                        method: method,
                        url: `${uri}${url}`,
                        data: body,
                        headers,
                    });
                }
            }

            setLoading(false);
            if (onSuccess) {
                onSuccess(response.data);
            }

            return response.data;
        } catch (err) {
            setLoading(false);
            console.log(err.response.data.message);
            setErrors(err.response.data.message);
        }
    };

    return {doRequest, errors, loading};
};
